import React from 'react'
import { getAsset } from '../services/assets'
import { Language, t } from '../data/translations'
import AnimatedCounter from './AnimatedCounter'

import EssenceButtonBackground from './EssenceButtonBackground'
import { ElementWaveSignal } from './WaveSignal'
import { useState } from 'react'
import { useShellLayout } from '../hooks/useShellLayout'

const EssenceManager: React.FC<{
  essence: number;
  onClick: () => void;
  isActive: boolean;
  canActivate: boolean;
  language: Language;
  hint?: { isAIBest: boolean };
}> = ({ essence, onClick, isActive, canActivate, language, hint }) => {
  const [triggerCount, setTriggerCount] = useState(0);
  const { isMobileShell } = useShellLayout();
  const shellSizeClass = isMobileShell ? 'w-24 h-24' : 'w-32 h-32';
  const canToggle = canActivate || isActive;

  const handleClick = () => {
    if (canToggle) {
      setTriggerCount(prev => prev + 1);
      onClick();
    }
  };

  return (
    <div id="btn-essence-mode" data-active={isActive ? 'true' : 'false'} className={`relative ${shellSizeClass} rounded-full flex items-center justify-center`}>
      <EssenceButtonBackground isActive={isActive} canActivate={canActivate} triggerAnimation={triggerCount} />
      {hint && (
        <ElementWaveSignal
          isAIBest={hint.isAIBest}
          elementType="BUTTON"
          shape="CIRCLE"
        />
      )}
      <button
        onPointerDownCapture={(e) => { e.stopPropagation(); }}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleClick(); }}
        disabled={!canToggle}
        className={`relative z-10 w-full h-full rounded-full flex flex-col items-center justify-center text-white transition-all duration-300 transform hover:scale-105 border-4 disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none bg-transparent ${isActive ? 'border-cyan-300 shadow-[0_0_25px_rgba(6,182,212,0.8)]' : 'border-slate-600'}`}
        style={{ touchAction: 'none' }}
      >
        <div className={`bg-black/40 backdrop-blur-sm ${isMobileShell ? 'px-2.5 py-1' : 'px-3 py-1'} rounded-[1.5rem] flex flex-col items-center border border-white/5 shadow-sm w-fit mx-auto`}>
          <div className="flex items-center justify-center">
            <AnimatedCounter value={essence} fontSize={isMobileShell ? 28 : 36} fontWeight="bold" minDigits={2} className="tracking-tighter leading-none drop-shadow-md" />
          </div>
          <span className={`${isMobileShell ? 'text-[8px]' : 'text-[9px]'} font-bold mt-0.5 uppercase tracking-widest text-cyan-100/90`}>{t('ui.essence', language)}</span>
        </div>
      </button>
    </div>
  )
}

export default EssenceManager
